import ProductDescription from './ProductDescription'

const FatReducedMilkProduct = {
  ...ProductDescription,
  category: '52',
  subCategory: '',
  IsBroadband: false,
  ReducedFatMilkType: '',
  ReducedFatMilkSize: '',
}

export default FatReducedMilkProduct
